import React from "react";
import { Button, Badge, Box } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import { useUser } from "../../context/AuthContext";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const ActionButtonWithoutUpload = ({
  onFilterClick,
  onAddClick,
  filterObj,
}) => {
  const { user } = useUser();
  const isFilterApplied = Object.keys(filterObj).some(
    (key) =>
      filterObj[key] &&
      (Array.isArray(filterObj[key])
        ? filterObj[key].length > 0
        : filterObj[key])
  );
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: "2rem",
        mb: "1.5rem",
        gap: "1rem",
      }}
    >
      {!user.companyAdmin ? (
        <Button
          variant="contained"
          endIcon={<AddIcon />}
          sx={{
            backgroundColor: "#1c486b",
            fontSize: "16px",
            textTransform: "none",
            fontFamily: "Inter",
            fontWeight: "500",
            "&:hover": {
              backgroundColor: "#1c486b",
              opacity: 0.9,
            },
          }}
          onClick={onAddClick}
        >
          Add New
        </Button>
      ) : null}

      <Button
        variant="contained"
        sx={{
          backgroundColor: "#ffffff",
          textTransform: "none",
          fontSize: "16px",
          fontFamily: "Inter",
          fontWeight: "500",
          color: "black",
          "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
          "&:hover .dot-icon": { color: "#FFFFFF" },
        }}
        onClick={onFilterClick}
      >
        Filter
        <FilterListIcon sx={{ marginLeft: "0.5rem" }} />
        {isFilterApplied && (
          <FiberManualRecordIcon
            className="dot-icon"
            sx={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#488257",
              marginLeft: "5px",
              fontFamily: "Inter",
              textTransform: "none",
            }}
          />
        )}
      </Button>
    </Box>
  );
};

export default ActionButtonWithoutUpload;
